import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { CleanupTemplateVersionsDocument } from './cleanup.generated';

export const useCleanupTemplateVersions = (
  options: ApiOptions<typeof CleanupTemplateVersionsDocument> = {},
) => {
  const { t } = useTranslation();

  return useMutation(CleanupTemplateVersionsDocument, {
    ...useNotifications(CleanupTemplateVersionsDocument, {
      failure: t('api.common.error_generic'),
      success: (data) => {
        const deleted = data.cleanupTemplateVersions?.deletedIds.length ?? 0;
        return t('api.templates.cleanup_success_plural', { count: deleted });
      },
    }),

    ...options,
  });
};
